import React from "react";

const Multiple_Parameters = () => {
  return (
    <div>
      <h1>Multiple_Parameters Component</h1>
      <p>Content for Multiple_Parameters goes here...</p>
    </div>
  );
};

export default Multiple_Parameters;
